import { css, styled, TextV2 } from '@withjoy/joykit';

/** Shared underline treatment for links and text actions, including labels inside clickable cards. */
export const dottedUnderlineStyles = css`
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-thickness: 1px;
  text-underline-offset: 25%;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

/**
 * A dotted-underline text action on a line of its own. A styled TextV2 so `forwardedAs` can make it a
 * button while TextV2 keeps its type, color and size.
 */
export const StyledStandaloneTextButton = styled(TextV2)`
  ${dottedUnderlineStyles}
`;
